/**
 * @title 互动答题
 */
export default [
  // 互动答题详情页-学生端
  {
    path: '/InteractiveAnswers/detail',
    name: '互动答题详情',
    component: () => import(/* webpackChunkName: "InteractiveAnswers" */ '@/views/InteractiveAnswers/detail/detail.vue')
  },
  // 互动答题详情页-老师端
  {
    path: '/InteractiveAnswers/detailTeacher',
    name: '互动答题详情2',
    component: () => import(/* webpackChunkName: "InteractiveAnswers" */ '@/views/InteractiveAnswers/detailTeacher/detailTeacher.vue')
  },
  // 展示互动试题
  {
    path: '/InteractiveAnswers/questionExhibition',
    name: '展示互动试题',
    component: () => import(/* webpackChunkName: "InteractiveAnswers" */ '@/views/InteractiveAnswers/questionExhibition/questionExhibition.vue')
  },
  // 试题预览
  {
    path: '/InteractiveAnswers/preview',
    name: '试题预览2',
    component: () => import(/* webpackChunkName: "InteractiveAnswers" */ '@/views/InteractiveAnswers/preview/preview.vue')
  },
  // 开始答题
  {
    path: '/InteractiveAnswers/answer',
    name: '',
    component: () => import(/* webpackChunkName: "InteractiveAnswers" */ '@/views/InteractiveAnswers/answer/answer.vue')
  },
  // 答题成功页
  {
    path: '/InteractiveAnswers/success',
    name: '作答成功',
    component: () => import(/* webpackChunkName: "InteractiveAnswers" */ '@/views/InteractiveAnswers/submitSuccess/submitSuccess.vue')
  },
  // 答题结果
  {
    path: '/InteractiveAnswers/answerResults',
    name: '答题结果',
    component: () => import(/* webpackChunkName: "InteractiveAnswers" */ '@/views/InteractiveAnswers/answerResults/answerResults.vue')
  },
  // 批阅互动答题
  {
    path: '/reviewAnswer',
    name: 'ReviewAnswer',
    component: () => import(/* webpackChunkName: "InteractiveAnswers" */ '@/views/InteractiveAnswers/reviewAnswer/reviewAnswer.vue')
  },
  {
    path: '/InteractiveAnswers/reviewAnswerDetail',
    name: '题目解析',
    component: () => import(/* webpackChunkName: "InteractiveAnswers" */ '@/views/InteractiveAnswers/answerResultDetail/index.vue')
  },
  {
    path: '/documentView/interactpptSubjectLists',
    name: '试题列表',
    component: () => import(/* webpackChunkName: "InteractiveAnswers" */ '@/views/virtualTeachingAndResearchOffice/documentView/interactppt/questionLists.vue')
  }
];
